export const REPLAY_COPY = {
  replay: "Replay",
  play: "Play",
  pause: "Pause",
  speed: "Speed",
  follow: "Follow",
  exit: "Exit replay",
  empty: "No versions yet",
  loadFailed: "Couldn't load versions",
  version: "Version",
} as const;
